function n(r, o) {
  console.error(`[vdirs/${r}]: ${o}`);
}
export {
  n as warn
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vdirs@0.1.8_vue@3.5.18/~/vdirs/es/utils.js
// module id = 1734
// module chunks = 41